import aggiungi from  './aggiungi'
import emettiFattura from './emetti-fattura'
import estrattoConto from './estratto-conto'
import estrattoContoDettagliato from './estratto-conto-dettagliato'
import multiProspettoCicloPagamenti from './multi-prospetto-ciclo-pagamenti'

export default [
  // always
  {
    'key': 'rappresentanti-button-aggiungi',
    'label': 'Crea Nuovo Rappresentante',
    'classCss': 'p-button-secondary',
    icon: " pi pi-plus",
    'type': 'operation',
    'method': aggiungi,
    'display': 'always'
  },

  // on-data-filtered
  {
    'key': 'clienti-button-estratto-conto',
    'label': 'ESTRATTO CONTO',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-directions',
    'type': 'operation',
    'method': estrattoConto,
    'display': 'on-data-filtered'
  },
  {
    'key': 'clienti-button-estratto-conto-dettagliato',
    'label': 'ESTRATTO CONTO DETTAGLIATO',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-directions',
    'type': 'operation',
    'method': estrattoContoDettagliato,
    'display': 'on-data-filtered'
  },
  {
    'key': 'rappresentanti-button-emetti-fattura',
    'label': 'EMETTI FATTURA',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-directions',
    'type': 'operation',
    'method': emettiFattura,
    'display': 'on-data-filtered'
  },
  {
    'key': 'rappresentanti-button-prospetto-ciclo-pagameti-multi',
    'label': 'MULTI PROSPETTO CICLO PAGAMENTI',
    'classCss': 'p-button-success',
    'icon': ' pi pi-align-left',
    'type': 'operation',
    'method': multiProspettoCicloPagamenti,
    'display': 'on-data-filtered'
  },
]
